export default __webpack_public_path__ + "static/media/Slack-Logo.1d45ae9c.svg";